/**
 * Created by thiago on 26/11/16.
 */
angular.module('appSite').config(['uiMask.ConfigProvider', function (uiMaskConfigProvider) {
    if (navigator.userAgent.indexOf('Android') > 0) {
        uiMaskConfigProvider.eventsToHandle(['keyup', 'click', 'focus']);
    }
}]);